import { useModal } from 'vue-final-modal';

import routes from '@/constants/routes';

import ModalsAuthCode from '@/components/modals/AuthCode.vue';
import ModalsEmail from '@/components/modals/Email.vue';

export const useAuthModals = () => {
  const authStore = useAuthStore();
  const localePath = useLocalePath();
  const { t } = useI18n();

  const authCodeModal = useModal({
    component: ModalsAuthCode,
    attrs: {
      onSubmit({ email, code }) {
        authStore
          .mergeGuestAndUser({ email, code })
          .then(() => {
            authCodeModal.close();
            navigateTo(localePath(routes.MY_TICKETS));
          })
          .catch((response) => {
            authCodeModal.patchOptions({
              attrs: {
                errors: { code: response.data.message },
              },
            });
          });
      },
      onResend(email) {
        authStore.requestLoginCode(email);
      },
    },
  });

  const authEmailModal = useModal({
    component: ModalsEmail,
    attrs: {
      title: () => t('modals.auth.title'),
      text: () => t('modals.auth.text'),
      buttonText: () => t('modals.auth.proceed'),
      autocompleteEmail: false,
      onSubmit(email) {
        authEmailModal.patchOptions({
          attrs: {
            isSending: true,
          },
        });

        authStore
          .requestLoginCode(email)
          .then(() => {
            authCodeModal.patchOptions({
              attrs: {
                email,
              },
            });

            authEmailModal.close();
            authCodeModal.open();
          })
          .catch((response) => {
            authEmailModal.patchOptions({
              attrs: {
                errors: response?.data?.errors,
              },
            });
          })
          .finally(() => {
            authEmailModal.patchOptions({
              attrs: {
                isSending: false,
              },
            });
          });
      },
    },
  });

  return { authEmailModal };
};
